<template>
  <el-dialog
    class="dialog-inner"
    :model-value="visible"
    :before-close="() => {
      emit('close');
    }"
    width="600"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 text-xl text-[#344767] font-semibold">
          提现
        </h4>
      </div>
    </template>

    <div class="px-2 pb-3 relative">
      <el-form
        ref="formRef"
        require-asterisk-position="right"
        label-position="top"
        :model="formValues"
        :rules="formRules"
      >
        <el-form-item prop="amount" label="提现金额（元）">
          <el-input v-model="amount" size="large" disabled />
        </el-form-item>
        <el-form-item label="管理手机号">
          <el-input v-model="regPhone" size="large" disabled class="ipt" />
        </el-form-item>
        <el-form-item label="短信验证码" prop="verifyCode">
          <el-input v-model="formValues.verifyCode" size="large" placeholder="请输入" />
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="flex justify-center">
        <el-button @click="emit('close')">
          取消
        </el-button>
        <el-button type="primary" :loading="loading" @click="onConfirm">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { checkSmsCode } from '@core/tools';
import { ElMessage, FormInstance, FormRules } from 'element-plus';
import { computed, nextTick, PropType, ref, toRaw, watch } from 'vue';
import { IFinanceWallet, IFinanceLianWithdrawVerify } from '@core/main/types';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object as PropType<IFinanceWallet>,
    default: () => ({}),
  },
  validInfo: {
    type: Object as PropType<{ validToken: string; txnId: number }>,
    default: () => ({}),
  },
  loading: {
    type: Boolean,
    default: false,
  },
  term: {
    type: String as PropType<'server' | 'company' | 'agent'>,
    default: 'server',
  },
  payPhone: {
    type: String,
    default: '',
  },
});

const formRef = ref<FormInstance>();
const formValues = ref({} as IFinanceLianWithdrawVerify);

const amount = computed(() => props.data.availableBalance);
const regPhone = computed(() => props.data.regPhone);

const formRules = ref<FormRules<any>>({
  verifyCode: [
    {
      required: true,
      message: '请输入短信验证码',
    },
    {
      required: true,
      validator: (rule: any, value: string, callback: any) => {
        if (checkSmsCode(String(formValues.value.verifyCode))) {
          callback(checkSmsCode(String(formValues.value.verifyCode)));
        }
        callback();
      },
    },
  ],
});

function onConfirm() {
  formRef.value?.validate(async (valid) => {
    if (valid) {
      const params = {
        lianId: Number(props.data.accountId),
        ...toRaw(formValues.value),
        amount: undefined,
        txnId: props.validInfo.txnId,
        token: props.validInfo.validToken,
      } as IFinanceLianWithdrawVerify;

      emit('confirm', params);
    }
  });
}

function resetForm() {
  for (const key in formValues.value) {
    formValues.value[key] = undefined;
  }
}

watch(
  () => props.visible,
  (val) => {
    if (val) {
      ElMessage.info('短信验证码已发送，请注意查收');
      resetForm();
      nextTick(() => {
        formRef.value?.resetFields();
      });
    }
  },
);
</script>

<style lang="scss" scoped>
:deep(.dialog-inner .el-dialog__body) {
  overflow-y: unset !important;
}

.with-cash-title {
  padding: 0 0 10px 0;

  span {
    font-weight: 600;
  }

  label {
    font-weight: normal;

    strong {
      color: #f00;
    }
  }
}

.with-cash-content {
  padding: 26px 0;
  box-sizing: border-box;

  .lianlian-pass-field {
    width: 300px;
  }
}
</style>
